import { LuckyWheel } from '@lucky-canvas/react';
import { useEffect, useRef, useState } from 'react';

import { implog } from '@/api/implog';
import { updateWhatsappStatus } from '@/api/share';
import { CloseOutLine } from '@/components/icons/icons';

// import lottery_bg from '@/pages/whatsapp/assets/lottery_bg.webp';
// import lottery_btn from '@/pages/whatsapp/assets/lottery_btn.webp';
// import lottery_content from '@/pages/whatsapp/assets/lottery_content.webp';
import styles from './styles.module.less';

const ModalWheel = (modal: any, onClose, innerProps) => {
  const { closable } = innerProps;
  const [wheelNum, setWheelNum] = useState(1);
  const [blocks] = useState([
    {},
    {
      imgs: [
        {
          src: `${window?.imgPrefix || ''}/img/whatsapp/lottery_content.webp`,
          width: '4.6rem',
          height: '4.6rem',
          padding: '0',
          rotate: true
        }
      ]
    }
  ]);
  const [prizes] = useState([{ prize: 6 }, { prize: 1 }, { prize: 2 }, { prize: 3 }, { prize: 4 }, { prize: 5 }]);
  const [buttons] = useState([
    {
      radius: '100%',
      imgs: [
        {
          src: `${window?.imgPrefix || ''}/img/whatsapp/lottery_btn.webp`,
          width: '1.76rem',
          height: '1.93rem',
          top: '-1.03rem',
          onClick: () => {
            // console.log('开始抽奖');
          }
        }
      ]
    }
  ]);
  const myLucky: any = useRef();
  useEffect(() => {
    implog('wa_activate_show');
  }, []);
  return (
    <div className={styles.wheel_container}>
      {closable ? (
        <CloseOutLine
          className={styles.close_icon}
          onClick={() => {
            modal.resolve({ onClose });
          }}
        ></CloseOutLine>
      ) : null}
      <div
        className={styles.wheel}
        onClick={async () => {
          implog('wa_activate_click');
          await updateWhatsappStatus();
          setWheelNum(0);
          // 点击抽奖按钮会触发star回调
          myLucky?.current?.play();
          setTimeout(async () => {
            myLucky?.current?.stop(3);
          }, 2500);
        }}
      >
        <LuckyWheel
          ref={myLucky}
          width="4.6rem"
          height="4.6rem"
          blocks={blocks}
          prizes={prizes}
          buttons={buttons}
          // onStart={async () => {
          //   await updateWhatsappStatus();
          //   setWheelNum(0);
          //   // 点击抽奖按钮会触发star回调
          //   myLucky?.current?.play();
          //   setTimeout(async () => {
          //     myLucky?.current?.stop(3);
          //   }, 2500);
          // }}
          onEnd={async (prize: any) => {
            // console.log('中奖结果:', prize, modal);
            setTimeout(() => {
              modal.resolve({ prize, onClose });
            }, 500);
          }}
        />
        <div className={styles.wheel_num}>{wheelNum}</div>
      </div>
      <div className={styles.wheel_container_bg} />
    </div>
  );
};

export default ModalWheel;
